import { render, staticRenderFns } from "./MetricSquare.vue?vue&type=template&id=d0b13c9a&scoped=true"
import script from "./MetricSquare.vue?vue&type=script&lang=ts"
export * from "./MetricSquare.vue?vue&type=script&lang=ts"
import style0 from "./MetricSquare.vue?vue&type=style&index=0&id=d0b13c9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b13c9a",
  null
  
)

export default component.exports